import { gql } from '@apollo/client';

const getCancelBookingByID = gql`
  query GetCancelBookingById($getBookingById: ID!) {
    getBookingByID(id: $getBookingById) {
      bookedFrom
      bookedTo
      guestAdultCount
      guestChildrenCount
      guestInfantCount
      id
      lastArrival
      metadata
      price
      reference
      status
      usedEntitlementsCount
    }
  }
`;

export default getCancelBookingByID;
